import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../HandleAPICalls/actions";
import CreateRoster from "./Component.jsx";
import SuccessDialog from "./SuccessDialog";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const Create_Cst_Roster_Container = (props) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [agentListData, setAgentListData] = useState([]);
  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);

  const create_roster = (payload) => {
    console.log("Sending payload to API:", payload);
    setLoading(true);
    props.getDataFromAPI(
      "/partner/api/v1/chat-assignment/update-agent",
      "PUT",
      payload,
      (response) => {
        console.log("API Response:", response);
        setLoading(false);
        
        // Show success dialog
        setOpenSuccessDialog(true);
      },
      (error) => {
        console.error("Error saving roster:", error);
        toast.error("Failed to create roster", {
          position: "top-right",
          autoClose: 2000,
        });
        setLoading(false);
      }
    );
  };

  const handleCloseSuccessDialog = () => {
    setOpenSuccessDialog(false);
    navigate(-1); // Navigate back after closing dialog
  };

  const Rooster_agent_list = () => {
    setLoading(true);
    props.getDataFromAPI(
      "/partner/api/v1/whatsapp/agent",
      "GET",
      undefined,
      (response) => {
        console.log("Agent list response:", response);
        // Extract agents from response
        let agents = [];
        if (response?.data && Array.isArray(response.data)) {
          agents = response.data;
        } else if (Array.isArray(response)) {
          agents = response;
        } else if (response?.agents && Array.isArray(response.agents)) {
          agents = response.agents;
        }
        
        console.log("Extracted agents:", agents);
        setAgentListData(agents);
        setLoading(false);
      },
      (error) => {
        console.error("Error fetching agents:", error);
        setLoading(false);
      }
    );
  };

  useEffect(() => {
    Rooster_agent_list();
  }, []);

  return (
    <>
      <SuccessDialog 
        open={openSuccessDialog} 
        onClose={handleCloseSuccessDialog} 
      />
      <CreateRoster
        agentListData={agentListData}
        onPayloadReady={(payload) => {
          create_roster(payload);
        }}
        loading={loading}
      />
    </>
  );
};

export default connect(null, { getDataFromAPI })(Create_Cst_Roster_Container);